module.exports = __webpack_public_path__ + "img/bg_bd.9338768c.png";